"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/utils/assets");
var actions = _interopRequireWildcard(require("./actionTypes"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  data: {},
  ui: {
    isLoadingUnderlyingTerms: false,
    isUpdatingVisibility: false
  }
};
function updatedGroupInstanceInArray(_ref) {
  var _ref$instances = _ref.instances,
    instances = _ref$instances === void 0 ? [] : _ref$instances,
    apiGroupInstanceId = _ref.apiGroupInstanceId,
    isPublic = _ref.isPublic;
  return instances.map(function (apiGroupInstance) {
    var id = apiGroupInstance.id;
    if (id !== apiGroupInstanceId) {
      return apiGroupInstance;
    }
    return _objectSpread(_objectSpread({}, apiGroupInstance), {}, {
      isPublic: isPublic
    });
  });
}
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var apiVersionPath = (0, _assets.getGAPKey)(action);
  switch (action.type) {
    case actions.LIST_GROUP_INSTANCES.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, apiVersionPath, _objectSpread(_objectSpread({}, state.data[apiVersionPath]), {}, {
          instances: action.result
        })))
      });
    case actions.GET_UNDERLYING_API_TERMS.REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoadingUnderlyingTerms: true
        })
      });
    case actions.GET_UNDERLYING_API_TERMS.SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, apiVersionPath, _objectSpread(_objectSpread({}, state.data[apiVersionPath]), {}, {
          underlyingTerms: action.result
        }))),
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isLoadingUnderlyingTerms: false
        })
      });
    case actions.UPDATE_API_GROUP_INSTANCE.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isUpdatingVisibility: true
          })
        });
      }
    case actions.UPDATE_API_GROUP_INSTANCE.SUCCESS:
      {
        var _state$data$apiVersio;
        var params = action.params;
        var apiGroupInstanceId = params.apiGroupInstanceId,
          isPublic = params.isPublic;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, apiVersionPath, _objectSpread(_objectSpread({}, state.data[apiVersionPath]), {}, {
            instances: updatedGroupInstanceInArray({
              instances: (_state$data$apiVersio = state.data[apiVersionPath]) === null || _state$data$apiVersio === void 0 ? void 0 : _state$data$apiVersio.instances,
              isPublic: isPublic,
              apiGroupInstanceId: apiGroupInstanceId
            })
          }))),
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isUpdatingVisibility: false
          })
        });
      }
    case actions.UPDATE_API_GROUP_INSTANCE.FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isUpdatingVisibility: false
          })
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map